<template>
  <v-container fluid style="padding: 0; min-height: 100vh">
    <template v-if="!lg">
      <chatbox></chatbox>
    </template>
    <template v-if="lg">
      <ChatboxLG></ChatboxLG>
    </template>
  </v-container>
</template>

<script>
import ChatboxLG from './ChatboxLG.vue'
import Chatbox from './Chatbox.vue'
export default {
  components: {
    Chatbox,
    ChatboxLG
  },
  computed: {
    lg() {
      return this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl
    }
  }
}
</script>

<style lang="scss" scoped></style>
